import VehiclesPage from './components/VehiclesPage';

const routes = [
  {
    path: '/vehicles',
    name: 'menu.vehicles',
    icon: 'scooter',
    // customIcon: true,
    loginRequired: true,
    component: VehiclesPage,
    weight: 2,
    permission: [],
    children: [],
  },
];

export default routes;
